import React, { FC } from 'react';
import { PageLink, PageTitle } from '../../../../rbts/layout/core';
import { View } from './components/View';

const ReporteCAPage: FC = () => {
  const breadcrumbs: Array<PageLink> = [];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Reporte de Cargas y Abonos</PageTitle>
      <View />
    </>
  );
};

export { ReporteCAPage };
